/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutoApplyToggle/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import ReceivableMessage from './ReceivableMessage/index'
import Toggle from './Toggle/index'



/** @type {import('Simple/types.js').View} */
export default function AutoApplyToggle({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/AutoApplyToggle"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentsPostPaymentReceivableIdValueData = fromData.useDataFormat({ viewPath,
context: 'payments_post_payment',
path: 'receivable_id',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentsPostPaymentReceivableIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Toggle'}>
<Toggle
  viewPath={`${viewPath}/Toggle`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ReceivableMessage'}>
<ReceivableMessage
  viewPath={`${viewPath}/ReceivableMessage`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}